import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducer";
import { setSpecial as setSpecialAction } from "../../redux/slices/SpecialSlice";

const useSpecial = () => {
  const dispatch = useDispatch();

  const special = useSelector((state: RootState) => {
    const { Special } = state;

    return Special;
  });

  const setSpecial = useCallback(
    (param: string) => {
      dispatch(setSpecialAction(param));
    },
    [dispatch]
  );

  return { special, setSpecial };
};

export default useSpecial;
